import { createTheme, Theme } from '@mui/material/styles';
import componentsOverride from 'themes/overrides';
import { generateColorVariants } from 'utils/theme-helper';

import { FreezeTemperature, PRESERVATION_INK, TEMPERATURE } from './freezeUi';

/** A dark theme scoped to the freeze flow's body. The app's overrides are re-derived because they bake
 *  palette values in at creation; the outer theme's would paint light-mode colours on ice. */
export function glacialTheme(base: Theme, temperature: FreezeTemperature): Theme {
  const accent = generateColorVariants(TEMPERATURE[temperature].accent).default;
  const theme = createTheme({
    ...base,
    palette: {
      ...base.palette,
      mode: 'dark',
      // The accent is a pale tint, so ink on it has to be the surface, not white.
      primary: { ...accent, contrastText: TEMPERATURE[temperature].ink },
      background: { default: PRESERVATION_INK.surface, paper: PRESERVATION_INK.panel },
      text: { primary: PRESERVATION_INK.high, secondary: PRESERVATION_INK.medium, disabled: PRESERVATION_INK.low },
      divider: PRESERVATION_INK.hairline,
      border: { main: PRESERVATION_INK.hairline }
    }
  });
  theme.components = componentsOverride(theme);
  return theme;
}
